import styled from 'styled-components'
import FadeInUpWrapper from '../../common/FadeInUpWrapper'

const Container = styled(FadeInUpWrapper)`
  width: 800px;
  background: white;
  margin-top: 123px;
  max-height: 90vh;
  box-shadow: 0 4px 10px -2px rgba(0, 0, 0, 0.3);
`

const Header = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  background: #75afb6;
  padding: 20px;
`

const Body = styled.div`
  padding: 20px 30px;
  font-size: 16px;
  overflow-y: scroll;
  max-height: 70vh;
  box-sizing: border-box;
`

const Title = styled.div`
  grid-column-start: 2;
  grid-column-end: 2;
  color: white;
  align-self: center;
  justify-self: center;
  font-size: 18px;
`

const Line = styled.hr`
  margin: 0 !important;
`

const Close = styled.span`
  color: white;
  grid-column-start: 3;
  grid-column-end: 3;
  cursor: pointer;
  justify-self: end;
  align-self: center;
  font-weight: bold;
  font-size: 11pt;
`

const DocumentTypeContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`

const DocumentTypeButton = styled.div`
  box-sizing: border-box;
  width: 48%;
  margin: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  height: 90px;
  &:hover {
    cursor: pointer;
    box-shadow: 0 0 3px 0 #ff9729;
    background-color: #cc6900;
    color: white;
    i {
      color: white !important;
    }
  }
  border: ${(props) =>
    props.active ? '2px solid #CC6900' : '1px solid #979797'};
  i {
    color: ${(props) => (props.active ? '#CC6900' : '')};
  }
`

const Signers = styled.div`
  width: 95%;
  margin: 20px 0;
`

const SignersForm = styled.form`
  margin-top: 10px;
  span {
    height: 25px;
    margin: 5px;
  }
  label {
    flex: 1;
  }
  div {
    display: flex;
    align-items: center;
  }
`

const SignerInput = styled.input`
  border: 1px solid #dbdbdc;
  border-radius: 2px;
  margin: 5px;
  height: 25px;
  width: ${(props) => props.width};
`

const SmallText = styled.span`
  font-size: ${(props) => props.size};
  color: ${(props) => props.color};
`

const AddSigner = styled.div`
  margin-top: 10px;
  height: 33px;
  width: 536px;
  border: 1px dashed #808284;
  display: flex;
  margin: 5px;
  color: #808284;
  font-size: 14px;
  align-items: center;
  cursor: pointer;
`

const Icon = styled.i`
  border-radius: 50%;
  border: ${(props) => (props.circleBorder ? '1px solid #808284' : 'none')};
  color: ${(props) => (props.circleBorder ? '#808284' : 'inherit')};
  height: 11px;
  width: 11px;
  display: flex;
  line-height: 15px;
  justify-content: center;
  align-items: center;
  background: none;
  padding: 5px;
  margin-left: 4px;
  margin-right: ${(props) => (props.circleBorder ? '0' : '10px')};
  cursor: pointer;
`

const BoldText = styled.span`
  font-weight: 600;
`

const Footer = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

const Button = styled.button`
  font-size: 16px;
  height: 44px;
  padding: 7px 20px;
  border-radius: 4px;
  border: none;
  margin-right: 20px;
  background-color: #dbdbdc;
  pointer-events: ${(props) => (props.disable ? 'none' : 'auto')};
`

const RadioInput = styled.input`
  margin: 0px 5px 0px 0px !important;
`

const ErrorContainer = styled.div`
  padding: 5px 10px;
  margin-bottom: 10px;
  background: #fdeded;
  font-size: 14px;
  border-radius: 4px;
  text-vverflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 127.5px 0;
`

export {
  Container,
  Header,
  Body,
  Title,
  Line,
  Close,
  DocumentTypeContainer,
  DocumentTypeButton,
  Signers,
  SignersForm,
  SignerInput,
  SmallText,
  AddSigner,
  Icon,
  BoldText,
  Footer,
  Button,
  RadioInput,
  ErrorContainer,
  LoadingContainer,
}
